import { BsFiletypeHtml, BsFiletypeCss, BsBootstrap } from "react-icons/bs";
import { FaNodeJs } from "react-icons/fa";
import {
  SiJavascript,
  SiReact,
  SiTailwindcss,
  SiMongodb,
  SiMysql,
  SiTypescript,
  SiGithub,
  SiFirebase,
  SiExpress,
  SiNginx,
  SiPostman,
  SiRedux,
} from "react-icons/si";
export const TechstackList = [
  {
    _id: 1,
    name: "HTML",
    icon: BsFiletypeHtml,
  },
  {
    _id: 2,
    name: "CSS",
    icon: BsFiletypeCss,
  },
  {
    _id: 3,
    name: "Bootstrap",
    icon: BsBootstrap,
  },
  {
    _id: 4,
    name: "Javascript",
    icon: SiJavascript,
  },
  {
    _id: 5,
    name: "TypeScript",
    icon: SiTypescript,
  },
  {
    _id: 6,
    name: "React JS",
    icon: SiReact,
  },
  {
    _id: 7,
    name: "Tailwind ",
    icon: SiTailwindcss,
  },
  {
    _id: 8,
    name: "Node JS ",
    icon: FaNodeJs,
  },
  {
    _id: 9,
    name: "Express JS ",
    icon: SiExpress,
  },
  {
    _id: 10,
    name: "Mongodb ",
    icon: SiMongodb,
  },
  {
    _id: 11,
    name: "SQL ",
    icon: SiMysql,
  },
  {
    _id: 12,
    name: "Firebase ",
    icon: SiFirebase,
  },
  {
    _id: 13,
    name: "Git / Github ",
    icon: SiGithub,
  },
  {
    _id: 14,
    name: "Nginx ",
    icon: SiNginx,
  },
  {
    _id: 15,
    name: "Postman ",
    icon: SiPostman,
  },
  {
    _id: 16,
    name: "Redux ",
    icon: SiRedux,
  },
];
